export enum RerunReasonType {
    FastingRequired = 1,
    PatientNotReady = 2,
    Other = 3,

    QcCalibrationFailure = 4,
    DeltaCheckFailure = 5,
    InstrumentError = 6,
    SampleDilutionRequired = 7,
    PhysicianClinicalRequest = 8,
}

export const RESCHEDULE_REASON_IDS: number[] = [
    RerunReasonType.FastingRequired,
    RerunReasonType.PatientNotReady,
    RerunReasonType.Other,
];

export const RERUN_TEST_REASON_IDS: number[] = [
    RerunReasonType.QcCalibrationFailure,
    RerunReasonType.DeltaCheckFailure,
    RerunReasonType.InstrumentError,
    RerunReasonType.SampleDilutionRequired,
    RerunReasonType.PhysicianClinicalRequest,
    RerunReasonType.Other,
];

export const RERUN_TEST_REASON_LABELS: { [key: number]: string } = {
    [RerunReasonType.QcCalibrationFailure]: 'QC/Calibration Failure',
    [RerunReasonType.DeltaCheckFailure]: 'Delta Check Failure',
    [RerunReasonType.InstrumentError]: 'Instrument Error',
    [RerunReasonType.SampleDilutionRequired]: 'Sample Dilution Required',
    [RerunReasonType.PhysicianClinicalRequest]: 'Physician/Clinical Request',
    [RerunReasonType.Other]: 'Other',
};